export class BaseError extends Error {
  constructor(message, ...args) {
    super(message, ...args);

    this.name = this.constructor.name;
  }
}
